import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { LESSON_PATHS } from "@/data/learningPath";

// Lightweight, fire-and-forget pageview tracking for lesson pages only.
// Records one event per (student, lesson) visit. Admin views are NOT recorded
// so the engagement numbers reflect students only.
export default function PageviewTracker() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const lastSent = useRef(null);

  useEffect(() => {
    if (!user || user === false) return;
    if (user.role === "admin") return;
    const path = (pathname || "").replace(/\/+$/, "") || "/";
    if (!LESSON_PATHS.includes(path)) return;
    if (lastSent.current === path) return;
    lastSent.current = path;
    axios
      .post("/api/analytics/pageview", { path }, { withCredentials: true })
      .catch(() => {});
  }, [pathname, user]);

  return null;
}
